// 政治面貌
export const outlookData = [
    {id: '中共党员', title: '中共党员'},
    {id: '中共预备党员', title: '中共预备党员'},
    {id: '共青团员', title: '共青团员'},
    {id: '民革会员', title: '民革会员'},
    {id: '民盟盟员', title: '民盟盟员'},
    {id: '民建会员', title: '民建会员'},
    {id: '民进会员', title: '民进会员'},
    {id: '农工党党员', title: '农工党党员'},
    {id: '致公党党员', title: '致公党党员'},
    {id: '九三学社社员', title: '九三学社社员'},
    {id: '台盟盟员', title: '台盟盟员'},
    {id: '无党派民主人士', title: '无党派民主人士'},
    {id: '群众', title: '群众'},
];

// 性别
export const contactsSexFilter = {
    0: '未知',
    1: '男', 
    2: '女', 
};
// 学历层次
export const educationLevelFilter = {
    1: '专升本', 
    2: '专升本', 
    3: '高起专',
};